var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card",attrs:{"header":_vm.uLang('app.create'),"header-tag":"h4"}},[(_vm.project)?_c('trajectory-form',{attrs:{"project":_vm.project,"overrideEndpoint":_vm.overrideEndpoint}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }